import React from 'react';
import { Text, View } from 'react-native';
import { TYPOGRAPHY } from '../../assets/theme';
import { makeStyles } from '../../theme/ThemeContext';
import { useLayout } from '../../theme/useLayout';

type PageHeaderProps = {
  title: string;
  subtitle?: string;
  /** Small uppercase label above the title. */
  eyebrow?: string;
  /** Actions shown on the right (desktop) or under the title (mobile). */
  actions?: React.ReactNode;
};

/** Large, left-aligned page title in the Airbnb style. */
export default function PageHeader({ title, subtitle, eyebrow, actions }: PageHeaderProps) {
  const styles = useStyles();
  const { isDesktop } = useLayout();

  return (
    <View style={[styles.row, !isDesktop && styles.rowMobile]}>
      <View style={styles.texts}>
        {eyebrow ? <Text style={styles.eyebrow}>{eyebrow}</Text> : null}
        <Text style={[styles.title, !isDesktop && styles.titleMobile]} accessibilityRole="header">
          {title}
        </Text>
        {subtitle ? <Text style={styles.subtitle}>{subtitle}</Text> : null}
      </View>
      {actions ? <View style={[styles.actions, !isDesktop && styles.actionsMobile]}>{actions}</View> : null}
    </View>
  );
}

const useStyles = makeStyles((c) => ({
  row: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    gap: 16,
    marginBottom: 24,
  },
  rowMobile: { flexDirection: 'column', alignItems: 'stretch', marginBottom: 16, gap: 12 },
  texts: { flexShrink: 1 },
  eyebrow: { ...TYPOGRAPHY.overline, color: c.primary, textTransform: 'uppercase', marginBottom: 6 },
  title: { ...TYPOGRAPHY.display, color: c.textPrimary },
  titleMobile: { fontSize: 26, lineHeight: 32 },
  subtitle: { ...TYPOGRAPHY.body, color: c.textSecondary, marginTop: 4 },
  actions: { flexDirection: 'row', alignItems: 'center', gap: 8, flexWrap: 'wrap' },
  actionsMobile: { justifyContent: 'flex-start' },
}));
